import { render } from "./App.vue?vue&type=template&id=8ea82c2a&scoped=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=8ea82c2a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-8ea82c2a"

export default script